import type { Eq } from 'fp-ts/lib/Eq';

export const keepIdentityIfEqual =
  <T>(eq: Eq<T>) =>
  (originalValue: T) =>
  (newValue: T): T =>
    eq.equals(originalValue, newValue) ? originalValue : newValue;
